// import { PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { PipeEnum } from '../helpers/constants';
import { ICobertura } from './productoColectivo.entities';

const enum ProductRoutes {
  individual = 'individual',
  colectivo = 'colectivo',
  vitalicio = 'vitalicio',
  privado = 'privado',
  children = 'children',
  detalle = 'detalle',
  resumen = 'resumen',
  salud = 'salud',
}

export interface IRoute {
  path: string;
  params?: object;
  label?: string;
  rootPath?: string;
  tabIndexes?: ITabIndexes;
  // children?: { [name: string]: IRoute };
  children?: { [key in ProductRoutes]?: IRoute };
}

export interface ITabIndexes {
  rootTabParent: number;
  rootTabChildren: number;
}
export interface ITabGroup {
  selectedIndex: number;
  tabs: ITab[];
}

export interface ITab {
  index: number;
  label: string;
  tabName: string;
  tabGroup?: ITabGroup;
  tabIndexes?: ITabIndexes;
}

// MENU ======================================
export interface IMenuItem {
  id?: any;
  route?: IRoute;
  label?: string;
  active?: boolean;
  item?: any;
  // path?: string;
  children?: IMenuItem[];
}

export interface IMenu {
  title: string;
  // individual?: boolean;
  route: IRoute;
  items: IMenuItem[];
}
// ========================================

export interface ILoaderState {
  show: boolean;
}

export interface IDatosEjecutiva {
  Rut: string;
  DV: string;
  Nombres: string;
  Apellidos: string;
  Mail: string;
  Telefono: string;
  idPoliza: string;
}

export interface IProducto {
  CodigoCliente?: string;
  Codigo?: string;
  IdPoliza: number;
  Nombre: string;
  Poliza?: number;
  IdCliente?: number;
  PolizaDescripcion?: string;
}

export interface ILineaNegocio {
  LineaNegocio: string;
  ListaProductos: {
    Producto: IProducto[];
  };
}
export interface IResumenPoliza {
  NumeroPoliza: string;
  IdentificadorPoliza: string;
  CodigoEstadoPoliza: string;
  EstadoPoliza: string;
  CodigoRamo: any;
  NombreProducto: string;
  Capital: number;
  CodigoMonedaCapital: string;
  MonedaCapital: string;
  FechaValorPoliza: string;
  FechaUltimoPago: string;
  MontoPesoDeuda: number;
  MontoUFDeuda: number;
  CodigoMonedaDeuda: string;
  MontoPesoVP: number;
  MontoUFVP: number;
  RegimenTributario: string;
  TipoProducto: string;
  ImagenProducto: string;
  Periodicidad: string;
  ViaPago: string;
  InicioVigencia: string;
  TerminoVigencia: string;
  FechaUltimoFacturado: string;
  PeriodicidadPrima: string;
  OpcionesMenu: IOpcionesMenu;
}

export interface IOpcionesMenu {
  DatosPoliza: boolean;
  Cartola: boolean;
  Traslado: string;
  Retiros: boolean;
  Rentabilidad: boolean;
  ValCuotas: boolean;
  EstadoPago: boolean;
}

export interface ICoberturaPoliza {
  NombreProducto: string;
  Poliza: string;
  Plan: string;
  Empresa: string;
  FechaVigencia: string;
  FechaVigenciaUI: string;
  Coberturas: string[];
}

export interface IResumenColectivo {
  CodigoPoliza: string;
  NumeroPoliza: number;
  NumeroRenovacion: string;
  FechaInicio: string;
  FechaTermino: string;
  FechaInicioUI: string;
  FechaTerminoUI: string;
  Rut: string;
  Dv: string;
  RazonSocial: string;
  NombreFantasia: string;
  CodigoAsegurado: string;
  CodigoPlan: string;
  Plan: string;
  Filial: string;
  FechaRenovacion: string;
  FechaRenovacionUI: string;
  Coberturas: string[];
  fechaInicioAsegurado: string;
  fechaTerminoAsegurado: string;
  fechaOriginalAsegurado: string;
  NumidEmpresaAseguradora: string;
  DvidEmpresaAseguradora: string;
}

export interface IResumenPolizaSalud {
  NumeroPoliza: string;
  IdentificadorPoliza: string;
  CodigoEstadoPoliza: string;
  NumeroPropuesta: string;
  EstadoPoliza: string;
  CodigoRamo: any;
  NombreProducto: string;
  Capital?: number;
  CodigoMonedaCapital?: string;
  MonedaCapital?: string;
  FechaValorPoliza?: string;
  FechaUltimoPago?: string;
  MontoPesoDeuda?: number;
  MontoUFDeuda?: number;
  CodigoMonedaDeuda?: string;
  MontoPesoVP?: number;
  MontoUFVP?: number;
  RegimenTributario?: string;
  TipoProducto?: string;
  ImagenProducto?: string;
  Periodicidad: string;
  ViaPago: string;
  InicioVigencia: string;
  TerminoVigencia: string;
  FechaUltimoFacturado?: string;
  PeriodicidadPrima?: string;
  Coberturas?: ICoberturaPoliza;
}

export interface IPolizaVitalicia {
  Afp: string;
  ApellidoPaterno: string;
  ApellidoMaterno: string;
  Banco: string;
  CuentaBancaria: string;
  FechaInicioPoliza: string;
  FechaInicioPolizaUI: string;
  FechaProximoPago: string;
  FechaProximoPagoUI: string;
  FechaRecepcionPrima: string;
  FechaRecepcionPrimaUI: string;
  FormaPago: string;
  Invalidez: string;
  Isapre: string;
  MesesDiferidos: string;
  MesesGarantizado: string;
  ModalidadRenta: string;
  MontoSalud: string;
  Nombre: string;
  Numero: string;
  Numero_persona: string;
  Periodicidad: string;
  PeriodoUltimoPago: string;
  PrimaTotalRecibida: 1304.41;
  RentaMensual: string;
  Rut: string;
  Tipo: string;
  TipoPension: string;
  TipoRenta: string;
  MesesAumentoTemporal: string;
  PorcentajeAumentoTemporal: string;
  Renta: string;
}

export interface IDatosAseguradoColectivo {
  Nombres: string;
  Apellidos: string;
  Rut: string;
  Telefono: string;
  Direccion: string;
  ComunaCodigo: any;
  Comuna: string;
  Region: string;
  RegionCodigo: string;
  BancoCodigo: string;
  Banco: string;
  TipoCuenta: string;
  NumeroCuenta: string;
  Ciudad: string;
  CiudadCodigo: string;
  Correo: string;
  FechaNacimiento: string;
}

export interface IDatoContratante {
  Rut: string;
  DV: string;
  TipoId: string;
  Nombres: string;
  Apellidos: string;
  TelefonoParticular: string;
  TelefonoComercial: string;
  DireccionParticular: string;
  DireccionComercial: string;
  Email: string;
  Programa: string;
  Intermediario: string;
  EmailInter: string;
  CodigoRegion: string;
  CodigoCiudad: string;
  CodigoComuna: string;
}

export interface IDatosContratanteProducto {
  LineaNegocio: string;
  Poliza: string;
  Nombre: string;
  ApellidoMaterno: string;
  ApellidoPaterno: string;
  Rut: string;
  ResumenContacto: string;

  Ciudad?: string;
  Comuna?: string;
  Region?: string;

  CodigoRegion: string;
  CodigoComuna: string;
  CodigoCiudad: string;
  Direccion: string;

  CodigoRegionComerc: string;
  regionComerc: string;
  CodigoComunaComerc: string;
  comunaComerc: string;
  CodigoCiudadComerc: string;
  ciudadComerc: string;
  DireccionComercial: string;

  CodigoRegionCorres: string;
  regionCorres: string;
  CodigoComunaCorres: string;
  comunaCorres: string;
  CodigoCiudadCorres: string;
  ciudadCorres: string;
  DireccionCorres: string;

  Celular: string;
  Correo: string;
  Usuario: string;
  CodigoBanco: string;
  TipoCuenta: string;
  NumeroCuenta: string;
  TelefonoComercial: string;
}

export interface IDatosContratanteRentista {
  Rut: string;
  Nombre: string;
  ApellidoPaterno: string;
  ApellidoMaterno: string;
  TelefonoParticular: string;
  TelefonoCelular: string;
  Mail: string;
  Direccion: string;
  Comuna: string;
  Ciudad: string;
  NumeroPersona: string;
  FormaPago: string;
  NumeroCuenta: string;
  Banco: string;
}

export interface IAsegurado {
  Apellidos: string;
  Capital: number;
  Cobertura: string;
  CodigoCobertura: string;
  CodigoParentesco: string;
  FechaNacimiento: string;
  IDCobertura: number;
  Parentesco: string;
  Nombres: string;
  PrimaBruta: number;
  DescripcionRamo: string;
  CodigoRamo: string;
  NombreCompleto: string;
  Rut?: string;
}

export interface IAseguradoGroup {
  producto: string;
  asegurados: IAsegurado[];
  displayedColumns: any[];
}

export interface IColumnsDataTable {
  ColumnName?: string;
  ColumnDef: string;
  Pipe?: PipeEnum;
  Icon?: boolean;
  IconAlign?: string;
  TextAlign?: string;
  TextStyle?: string;
  SvgIcon?: boolean;
  CheckBox?: boolean;
  Sum?: any;
  size?: string;
}

export interface IBeneficiario {
  Codigo: number;
  Numero: number;
  CodigoCliente: string;
  Tipo: string;
  Estado: string;
  Nombre: string;
  Participacion: string;
  Parentesco: string;
  Prioridad: string;
  hideIcon: boolean;
}
export interface IBeneficiarioVitalicio {
  Rut: number;
  Nombre: string;
  NombreCompleto: string;
  ApellidoPaterno: string;
  ApellidoMaterno: string;
  FechaNacimiento: string;
  FechaNacimientoUI: string;
  Telefono: string;
  TelefonoMovil: string;
  Correo: string;
  ciudad: string;
  Parentesco: string;
  Edad: number;
  Situacion: string;
  direccion: string;
  idPoliza: any;
  Sexo: string;
}

export interface IRegion {
  CodigoRegion: string;
  Nombre: string;
}

export interface ICiudad {
  CodigoCiudad: string;
  CodigoRegion: string;
  Nombre: string;
}

export interface IComuna {
  CodigoComuna: string;
  CodigoCiudad: string;
  Nombre: string;
}

export interface IPolizaPagoRealizado {
  Periodo: string;
  Monto: number;
  MontoMoneda: number;
  Moneda: string;
  FechaPago: string;
}

export interface IPolizaPagoPendiente {
  Poliza: number;
  Rut: string;
  IdePol: string;
  Producto: string;
  Monto: number;
  Periodo: string;
  NumAviso: number;
  DigAviso: string;
  FechaVencimiento: string;
  TipoProducto: string;
  TipoPrima: string;
  MedioPago: string;
  NombreProducto: string;
  Monto_UF: number;
  CodigoMoneda: string;
  Checked: boolean;
  index?: number;
}

export interface IpagoByIdPoliza {
  idPoliza: any;
  checkedPays: IPolizaPagoPendiente[];
}

export interface IBanco {
  Codigo: string;
  CodigoBanco: string;
  NombreBanco: string;
}

export interface ITipoCuenta {
  CodigoTipo: string;
  Nombre: string;
}

export interface IBeneficioCobrado {
  Codigo: number;
  Correlativo: number;
  FechaOcurrencia: string;
  FechaNotificacion: string;
  Asegurado: string;
  Descripcion: string;
  Monto: number;
  Estado: string;
  Producto: string;
}

export interface IEndoso {
  Codigo: string;
  FechaSolicitud: string;
  FechaEstado: string;
  Estado: string;
  Descripcion: string;
  Detalle: string;
}

export interface ICertificadoColectivo {
  AseguradoCodigo: string;
  CoberturaCodigo: string;
  Nombre: string;
  PlanCodigo: string;
  PolizaCodigo: string;
  ProductoCodigo: string;
  Tipo: string;
}

export interface IPeriodo {
  Anno: string;
  Rut: string;
  Poliza: string;
}

export interface ILiquidacion {
  NumeroLiquidacion: number;
  FechaLiquidacion: string;
  FechaLiquidacionUI: string;
  LiquidoPagar: number;
  TotalIngresos: number;
}

export interface InformationFTPBody {
  user?: string;
  connection: string;
  path: string;
  file: string;
}

export interface IInformationFTP {
  data: InformationFTPBody;
}

export interface InformacionFTPBody {
  usuario?: string;
  conexion: string;
  path: string;
  archivo: string;
}

export interface IInformacionFTP {
  InformacionFTP: InformacionFTPBody;
}
export interface IFormulario {
  nombre: string;
  descripcion: string;
  url: string;
  archivo: string;
}
export interface IDatoCategorias<T extends number | string> {
  codigo: T;
  descripcion: string;
}

export interface IGenero extends IDatoCategorias<string> {}
export interface IParentesco extends IDatoCategorias<number> {}

/* export const ICreditoPensionadoTableHeaders = {
  Pagare: { header: 'N DE PAGARE', },
  FechaOtorgamientoUI = 'FECHA OTORGAMIENTO',
  Monto = 'MONTO SOLICITADO($)',
  NumeroCuotas = 'N DE CUOTAS',
  MesesGracia = 'MESES DE GRACIA (CANTIDAD)',
  TasaInteres = 'TASA DE INTERES(%)',
  CAE = 'VALOR TASA(%)'
};
 */
export interface ICreditoPensionado {
  Pagare: number;
  FechaOtorgamiento: string;
  FechaOtorgamientoUI: string;
  Monto: string;
  NumeroCuotas: number;
  MesesGracia: string;
  TasaInteres: number;
  CAE: number;
  CodigoTPC: string;
}

export interface ICargaFamiliar {
  Correlativo: number;
  Nombre: string;
  ApellidoPaterno: string;
  ApellidoMaterno: string;
  Rut: string;
  Parentesco: string;
  FechaNacimiento: string;
  Edad: number;
}

export interface IOptionGroup {
  Title: string;
  Options: IOption[];
}

export interface IOption {
  Value: string;
  Name: string;
  Url?: string;
  Hidden?: boolean;
}

export enum TypeResponseApi {
  none,
  success,
  error,
}

export interface IDateRange {
  startDate: moment.Moment;
  endDate: moment.Moment;
}

export interface IDatoBeneficiario {
  idPoliza: any;
  Celular: string;
  CodCiudad: string;
  CodMunicipio: string;
  CodEstado: string;
  Email: string;
  Direccion: string;
  Rut: string;
  Telefono: string;
  TipoId: string;
  Nombre: string;
  Codigo: string;
  Numero: number;
}

export interface IPostDatoBeneficiario {
  Direccion: string;
  CodigoRegion: string;
  CodigoCiudad: string;
  CodigoMunicipio: string;
  Telefono: string;
  Celular: string;
  Correo: string;
  IdeAseg: string;
  NumBeneficiario: string;
}
export interface IScreenDim {
  width: number;
  height: number;
}

export interface ILLVAL {
  Descripcion: string;
}

export interface IResponseSolicitudCerficado {
  Codigo: number;
  Descripcion: string;
  Requerimiento: IRequerimientoSolicitud;
}
export interface IRequerimientoSolicitud {
  Id: string;
}

export interface ICaseSalesForce {
  Id: string;
  CaseNumber: string;
}

export interface IDocumentTicket {
  Codigo: number;
  Detalle: string;
  IdDocumento: number;
}

export interface IDocumentosAdjuntos {
  idTicket: number;
  nombreDocumento: string;
}

export interface IAsegurableResponde {
  httpCode: number;
  httpMessage: string;
  moreInformation: any[];
  userFriendlyError: any[];
  internal_id: string;
  isInsurable: boolean;
}

export interface IMandatoCliente {
  numeroPoliza: number;
  rut: number;
  dv: string;
  numeroMandato: number;
  periodo: string;
  formapago: string;
  nombrePoliza: string;
}

export interface IMandatoResponse {
  httpCode: number;
  httpMessage: string;
  moreInformation?: any;
  userFriendlyError?: any;
  internal_id: string;
  mandato: IMandatoCliente[];
}

// RDP: Datos para el modal de llamar ejecutiva
export interface IDatosModalCallEjecutiva {
  datosContratante: IDatosContratanteProducto;
  datosEjecutiva: IDatosEjecutiva;
}

//objeto retornado por historialreembolso
export interface HistorialReembolso {
  reimbursements: Reimbursement[];
  httpCode: number;
  httpMessage: string;
  internal_id: string;
  userFriendlyError: string;
  moreInformation: string;
}

export interface Reimbursement {
  id: string;
  presentationDate: string;
  beneficiary: Beneficiary;
  insured: Insured;
  coverage: Coverage;
  healthClaims: HealthClaims;
}

export interface Beneficiary {
  rutDv: string;
  fullName: string;
}

export interface Insured {
  rutDv: string;
}

export interface Coverage {
  code: string;
}

export interface HealthClaims {
  type: Type;
  totalAmount: TotalAmount;
  benefit: Benefit;
  bankAccount: BankAccount;
  status: Status;
}

export interface Type {
  code: string;
}

export interface TotalAmount {
  value: number;
  currency: string;
}

export interface Benefit {
  provider: Provider;
}

export interface Provider {
  rutDv: string;
}

export interface BankAccount {
  bank: Bank;
}

export interface Bank {
  code: string;
}

export interface Status {
  name: string;
}

export interface IDynamicComponentButton {
  text: string;
  link: string;
  variant: string;
}

export interface IDynamicComponentAvatar {
  name: string;
  color: string;
}

export interface IDynamicComponentData {
  title: string;
  description: string;
  variant: string;
  avatar: IDynamicComponentAvatar;
  redirectButton: IDynamicComponentButton;
  primaryButton: IDynamicComponentButton;
  cancelButton: IDynamicComponentButton;
}

export interface IDynamicComponentItem {
  type: string;
  data: IDynamicComponentData;
}

export interface IDynamicComponentList {
  typeComponent: string;
  componentList: IDynamicComponentItem[];
}

export interface IDynamicComponent {
  httpCode: number;
  httpMessage: string;
  moreInformation: string;
  internal_id: string;
  componentes: IDynamicComponentList;
}
